// /accounts/$a/tenants/$t/sites/$s/floors/$floorSlug — floor detail
// card + inline areas panel.

import { useQuery } from "@tanstack/react-query";

import { floors } from "../../api/endpoints/floors";
import { adminQueryOptions } from "../../api/adminQueryOptions";
import { qk } from "../../api/queryKeys";
import { ErrorBanner } from "../../components/ui/ErrorBanner";
import { PageHeader } from "../../components/shell/PageHeader";

import { AreaListPanel } from "../areas/AreaListPanel";

interface FloorDetailPageProps {
  accountSlug: string;
  tenantSlug: string;
  siteSlug: string;
  floorSlug: string;
}

export function FloorDetailPage({
  accountSlug,
  tenantSlug,
  siteSlug,
  floorSlug,
}: FloorDetailPageProps) {
  const q = useQuery({
    ...adminQueryOptions,
    queryKey: qk.floor(accountSlug, tenantSlug, siteSlug, floorSlug),
    queryFn: () =>
      floors.get(accountSlug, tenantSlug, siteSlug, floorSlug).then((r) => r.data),
  });

  return (
    <>
      <PageHeader
        title={q.data?.label ?? floorSlug}
        subtitle={
          q.data ? `${siteSlug} · level ${q.data.level}` : floorSlug
        }
      />

      {q.isPending && <p style={{ color: "var(--text-dim)" }}>Loading…</p>}
      {q.error && <ErrorBanner error={q.error} title="Failed to load floor" />}

      {q.data && (
        <section style={{ marginTop: 8 }}>
          <AreaListPanel
            accountSlug={accountSlug}
            tenantSlug={tenantSlug}
            siteSlug={siteSlug}
            floorSlug={floorSlug}
          />
        </section>
      )}
    </>
  );
}
